import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user-solid.svg'
import _imports_1 from '@/assets/images/users-solid.svg'
import _imports_2 from '@/assets/images/book-open-solid.svg'
import _imports_3 from '@/assets/images/clipboard-solid.svg'
import _imports_4 from '@/assets/images/id-card-solid.svg'
import _imports_5 from '@/assets/images/user-large-slash-solid.svg'
import _imports_6 from '@/assets/images/waiting-approval-user.svg'
import _imports_7 from '@/assets/images/chat-unread.svg'


const _withScopeId = n => (_pushScopeId("data-v-b8470ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "row gy-3 p-0 m-0"
}
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "bg-white shadow box-heading m-2" }
const _hoisted_8 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_9 = { class: "p-0 m-0" }
const _hoisted_10 = { class: "fs-7 text-black" }
const _hoisted_11 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_12 = { class: "fs-2" }
const _hoisted_13 = { class: "fs-85 text-gray" }
const _hoisted_14 = { class: "ms-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "bg-white shadow box-heading m-2" }
const _hoisted_18 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_19 = { class: "p-0 m-0" }
const _hoisted_20 = { class: "fs-7 text-black" }
const _hoisted_21 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_22 = { class: "fs-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_24 = { class: "col-lg-4" }
const _hoisted_25 = { class: "bg-white shadow box-heading m-2" }
const _hoisted_26 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_27 = { class: "p-0 m-0" }
const _hoisted_28 = { class: "fs-7 text-black" }
const _hoisted_29 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_30 = { class: "fs-2" }
const _hoisted_31 = { class: "fs-85 text-gray" }
const _hoisted_32 = { class: "ms-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_34 = { class: "col-lg-4" }
const _hoisted_35 = { class: "bg-white shadow box-heading m-2 mt-4" }
const _hoisted_36 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_37 = { class: "p-0 m-0" }
const _hoisted_38 = { class: "fs-7 text-black" }
const _hoisted_39 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_40 = { class: "fs-2" }
const _hoisted_41 = { class: "fs-85 text-gray" }
const _hoisted_42 = { class: "ms-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_44 = { class: "col-lg-4" }
const _hoisted_45 = { class: "bg-white shadow box-heading m-2 mt-4" }
const _hoisted_46 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_47 = { class: "p-0 m-0" }
const _hoisted_48 = { class: "fs-7 text-black" }
const _hoisted_49 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_50 = { class: "fs-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_52 = { class: "col-lg-4" }
const _hoisted_53 = { class: "bg-white shadow box-heading m-2 mt-4" }
const _hoisted_54 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_55 = { class: "p-0 m-0" }
const _hoisted_56 = { class: "fs-7 text-black" }
const _hoisted_57 = { class: "p-0 m-0 fw-bold text-number" }
const _hoisted_58 = { class: "fs-2" }
const _hoisted_59 = { class: "fs-85 text-gray" }
const _hoisted_60 = { class: "ms-2" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: "flag",
      class: "icon-header"
    })
  ])
], -1))
const _hoisted_62 = { class: "mx-4" }
const _hoisted_63 = { class: "text-header-left fs-7 text-header mt-3" }
const _hoisted_64 = {
  key: 1,
  class: "row gy-3 p-0 m-0"
}
const _hoisted_65 = { class: "col-lg-4" }
const _hoisted_66 = { class: "bg-white shadow box-heading-o m-2" }
const _hoisted_67 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_68 = { class: "p-0 m-0" }
const _hoisted_69 = { class: "fs-7 text-black" }
const _hoisted_70 = { class: "p-0 m-0 fw-bold text-number-o" }
const _hoisted_71 = { class: "fs-2" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon-o" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header-waiting-approval-user" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: "icon",
      class: "icon-header-waiting-approval-user"
    })
  ])
], -1))
const _hoisted_73 = { class: "col-lg-4" }
const _hoisted_74 = { class: "bg-white shadow box-heading-o m-2" }
const _hoisted_75 = { class: "d-flex px-4 py-2 justify-content-between" }
const _hoisted_76 = { class: "p-0 m-0" }
const _hoisted_77 = { class: "fs-7 text-black" }
const _hoisted_78 = { class: "p-0 m-0 fw-bold text-number-o" }
const _hoisted_79 = { class: "fs-2" }
const _hoisted_80 = { class: "fs-85 text-gray" }
const _hoisted_81 = { class: "ms-2" }
const _hoisted_82 = { class: "ms-2" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-4 div-icon-o" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-header" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: "icon",
      class: "icon-header"
    })
  ])
], -1))

import { translate } from '@/languages/i18n'
import { ref, onMounted } from 'vue'
import communityDashboardService from '@/services/community-dashboard.services'
import { useRoute } from 'vue-router'
import { numberWithCommas } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const latestInformation = ref({})
const loading = ref(false)
const postFirst = ref({})
const postSecond = ref({})
const postLast = ref({})
onMounted(async () => {
  loading.value = true
  try {
    const res = await communityDashboardService.getLatestInformation(route.params?.id)
    if (res.data?.success) {
      latestInformation.value = res?.data.data
      postFirst.value = latestInformation.value?.posts[1]
      postSecond.value = latestInformation.value?.posts[2]
      postLast.value = latestInformation.value?.posts[3]
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(translate)('CB10titleBox1')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.approved_users?.employees + latestInformation.value?.approved_users?.alumnus)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('CB10Enrolled')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.approved_users?.employees)), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(translate)('CB10Almunai')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.approved_users?.alumnus)), 1)
                  ])
                ]),
                _hoisted_15
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(translate)('CB10titleBox2')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.groups)), 1)
                  ])
                ]),
                _hoisted_23
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(translate)('CB10titleBox3')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(numberWithCommas)(postFirst.value?.employees + postFirst.value?.alumnus)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('CB10Enrolled')) + " : " + _toDisplayString(_unref(numberWithCommas)(postFirst.value?.employees)), 1),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(translate)('CB10Almunai')) + " : " + _toDisplayString(_unref(numberWithCommas)(postFirst.value?.alumnus)), 1)
                  ])
                ]),
                _hoisted_33
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(translate)('CB10titleBox4')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(numberWithCommas)(postSecond.value?.employees + postSecond.value?.alumnus)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_41, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('CB10Enrolled')) + " : " + _toDisplayString(_unref(numberWithCommas)(postSecond.value?.employees)), 1),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(translate)('CB10Almunai')) + " : " + _toDisplayString(_unref(numberWithCommas)(postSecond.value?.alumnus)), 1)
                  ])
                ]),
                _hoisted_43
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(translate)('CB10titleBox5')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(numberWithCommas)(postLast.value?.employees)), 1)
                  ])
                ]),
                _hoisted_51
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_55, [
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(translate)('CB10titleBox6')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_57, [
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unlogged_in_users?.employees + latestInformation.value?.unlogged_in_users?.alumni)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_59, [
                    _createElementVNode("span", null, _toDisplayString(_unref(translate)('CB10Enrolled')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unlogged_in_users?.employees)), 1),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(translate)('CB10Almunai')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unlogged_in_users?.alumni)), 1)
                  ])
                ]),
                _hoisted_61
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("p", _hoisted_63, _toDisplayString(_unref(translate)('CB10titleHeader2_1')), 1)
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_router_link, {
                to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/alumnus_candidates_waiting_approval?management_no=asc`,
                class: "a-decoration"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_68, [
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(translate)('CB10titleBox7')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_70, [
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.pending_users?.alumnus)), 1)
                      ])
                    ]),
                    _hoisted_72
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_router_link, {
                to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/manage_chat_room?tab=recruitment`,
                class: "a-decoration"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_76, [
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(translate)('CB10titleBox8')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_78, [
                        _createElementVNode("span", _hoisted_79, _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unread_chats?.recruitment + latestInformation.value?.unread_chats?.offer + latestInformation.value?.unread_chats?.direct)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_80, [
                        _createElementVNode("span", null, _toDisplayString(_unref(translate)('CB10Recruitment')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unread_chats?.recruitment)), 1),
                        _createElementVNode("span", _hoisted_81, _toDisplayString(_unref(translate)('CB10jobOffer')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unread_chats?.offer)), 1),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(translate)('CB10userDirect')) + " : " + _toDisplayString(_unref(numberWithCommas)(latestInformation.value?.unread_chats?.direct)), 1)
                      ])
                    ]),
                    _hoisted_83
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})